import { useState } from 'react';
import ExcelIcon from '@/assets/icons/V3/statistics/ExcelIcon.svg?react';
import { ChevronRight } from 'lucide-react';
import { Dialog, DialogTrigger, DialogContent, DialogClose } from '@/components/atoms/Dialog';
import { Button } from '@/components/atoms/PcButton';
import { useAppSelector } from '@/redux/store';
import { ROUTES } from '@/routes';
import { useMembershipPreviewMode } from '@/components/membership/MembershipContentLock';

// 날짜 유틸 함수는 위에서 정의

const ExcelNotice = () => {
  const [open, setOpen] = useState(false);
  const user = useAppSelector((state) => state.user);
  const isPreviewMode = useMembershipPreviewMode();
  const emailAddress = user.EmailAddreess || '';

  // 현재 달의 첫날과 마지막날을 반환
  function getMonthPeriod(date = new Date()) {
    const year = date.getFullYear();
    const month = date.getMonth(); // 0-based
    const firstDay = new Date(year, month, 1);
    const lastDay = new Date(year, month + 1, 0);
    return { firstDay, lastDay };
  }

  // 다음 달 10일 오전 10시 반환
  function getNextMonthSendDate(date = new Date()) {
    const year = date.getFullYear();
    const month = date.getMonth();
    // 다음 달 10일
    const nextMonth = month + 1;
    const nextYear = nextMonth > 11 ? year + 1 : year;
    const realNextMonth = nextMonth % 12;
    return new Date(nextYear, realNextMonth, 10, 10, 0, 0);
  }

  // 날짜를 '25.6.1' 등으로 포맷
  function formatShortDate(date: Date) {
    return `${String(date.getFullYear()).slice(2)}.${date.getMonth() + 1}.${date.getDate()}`;
  }

  // '25.7.10 오전 10시' 포맷
  function formatSendDate(date: Date) {
    return `${String(date.getFullYear()).slice(2)}.${
      date.getMonth() + 1
    }.${date.getDate()} 오전 10시`;
  }

  // 오늘 기준
  const now = new Date();
  const { firstDay, lastDay } = getMonthPeriod(now);
  const sendDate = getNextMonthSendDate(now);

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <div
          className="flex cursor-pointer items-center justify-between rounded-lg bg-gr-50 p-4"
          data-membership-preview-interactive={isPreviewMode ? 'true' : undefined}
        >
          <div className="flex gap-2">
            <div className="flex items-center justify-center gap-2 rounded-full bg-white p-2">
              <ExcelIcon />
            </div>
            <div className="flex flex-col gap-1">
              <div className="text-gr-800 Body1S16">이메일 등록 완료!</div>
              <div className="text-gr-700 Caption1M12">매출 파일을 발송해 드릴게요!</div>
            </div>
          </div>
          <div>
            <ChevronRight />
          </div>
        </div>
      </DialogTrigger>
      <DialogContent
        noCloseBtn
        className="max-w-[350px] p-[30px]"
        data-membership-preview-interactive={isPreviewMode ? 'true' : undefined}
      >
        <div className="flex h-full w-full flex-col gap-[20px]">
          <div className="flex flex-col gap-4">
            <div className="text-gr-900 Title3S18">정보를 확인해주세요</div>
            <div className="flex flex-col text-gr-700 Body5M14">
              <div>등록한 이메일로 매출 데이터 파일이 전송돼요.</div>
              <ul className="list-disc pl-5">
                <li>이메일 변경이 필요할 경우 1:1문의를 남겨주세요.</li>
              </ul>
            </div>
          </div>
          <div className="flex flex-col border-b border-t text-gr-700 Body5M14">
            <div className="flex items-center justify-between border-b py-[12px]">
              <div>이메일 주소</div>
              <div>{emailAddress || '등록되지 않음'}</div>
            </div>
            <div className="flex items-center justify-between border-b py-[12px]">
              <div>데이터 기간</div>
              <div>
                {formatShortDate(firstDay)} ~ {formatShortDate(lastDay)}
              </div>
            </div>
            <div className="flex items-center justify-between py-[12px]">
              <div>발송 예정일</div>
              <div>{formatSendDate(sendDate)}</div>
            </div>
          </div>

          <div className="flex w-full gap-3">
            <Button
              variant="muted"
              className="flex-1"
              onClick={() => {
                window.location.href = `${ROUTES.more}?ctab=support`;
              }}
            >
              1:1 문의
            </Button>

            <DialogClose asChild>
              <Button variant="default" className="h-[44px] flex-1">
                확인했어요
              </Button>
            </DialogClose>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default ExcelNotice;
